const unformattedDateElements: HTMLCollectionOf<HTMLDivElement> = <HTMLCollectionOf<HTMLDivElement>>document.getElementsByClassName("is-unformatted-date");

for(let i = 0; i < unformattedDateElements.length; ++i){
    const unformattedDateElement = unformattedDateElements.item(i)!;

    const dateData = Number(unformattedDateElement.textContent!);
    unformattedDateElement.textContent = new Date(dateData).toLocaleString();
}